export const version = { year: 2026, quarter: 3, commit: "528f1e6" };